module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "main",
    class: {
      searchshowing: _vm.searchShowing, whitenav: _vm.whiteNav
    }
  }, [_c('div', {
    staticClass: "menu-inner"
  }, [(!_vm.whiteNav) ? _c('ul', {
    staticClass: "primary-links"
  }, [_c('li', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "search"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.searchShowing = true
      }
    }
  }, [_vm._v("search")]), _vm._v(" "), _c('Autocomplete', {
    class: {
      searchshowing: _vm.searchShowing
    },
    attrs: {
      "searchPlaceholder": 'Search',
      "autoFocus": _vm.searchShowing,
      "styling": 'inheader'
    },
    on: {
      "searchBlur": function($event) {
        _vm.searchShowing = false
      },
      "select": _vm.searchSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.whiteNav) ? _c('div', {
    staticClass: "secondary-links"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "accountlinks"
  }, [_c('li', {
    staticClass: "account",
    on: {
      "click": function($event) {
        return _vm.$emit('accountClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.$emit('pullSheetClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("photo_library")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons desktop"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('span', [_vm._v("Pullsheet")])])])]) : _vm._e(), _vm._v(" "), (_vm.whiteNav) ? _c('ul', {
    staticClass: "primary-links"
  }, [_c('li', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo-purple.png")
    }
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "search"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.searchShowing = true
      }
    }
  }, [_vm._v("search")]), _vm._v(" "), _c('Autocomplete', {
    class: {
      searchshowing: _vm.searchShowing
    },
    attrs: {
      "autoFocus": _vm.searchShowing,
      "searchPlaceholder": 'Search Our Properties',
      "styling": 'whitenav'
    },
    on: {
      "searchBlur": function($event) {
        _vm.searchShowing = false
      },
      "select": _vm.searchSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.whiteNav) ? _c('div', {
    staticClass: "secondary-links"
  }, [_c('ul', {
    staticClass: "sitelinks"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/browse'
    }
  }, [_vm._v("Our Properties")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("Our Story")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "accountlinks"
  }, [_c('li', {
    staticClass: "account",
    on: {
      "click": function($event) {
        return _vm.$emit('accountClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.$emit('pullSheetClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("photo_library")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons desktop"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('span', [_vm._v("Pullsheet")])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "contactlinks"
  }, [_c('li', {
    staticClass: "phonenumber"
  }, [_c('a', {
    attrs: {
      "href": "tel:2133050464"
    }
  }, [_vm._v("213.305.0464")])]), _vm._v(" "), _c('li', {
    staticClass: "contactlink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:renee@therenees.com"
    }
  }, [_vm._v("Email")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ecd1edd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 197
// module chunks = 1